import { useState } from 'react'

import { ActionFab } from '../../../components/ActionButton'
import { PageTitle } from '../../../components/PageTitle'
import { useHasRole } from '../../../helpers'
import DutyPlannerFormModal from './DutyPlannerFormModal'
import DutyPlannerList from './DutyPlannerList'

export default function DutyPlannerPage() {
  const [isFormOpen, setIsFormOpen] = useState(false)
  const [id, setId] = useState<number>(1)
  const hasRole = useHasRole()
  const permissions = {
    addHoliday: hasRole('add_holiday')
  }

  return (
    <>
      <PageTitle title="Feriados e Plantões" description="Calendário de feriados e escalas de plantão" />
      <DutyPlannerList
        title="Próximos eventos"
        key={`next_${id}`}
        orderBy={{ direction: 'asc', key: 'date' }}
        show="upcoming"
      />
      <DutyPlannerList
        title="Eventos passados"
        key={`past_${id}`}
        orderBy={{ direction: 'desc', key: 'date' }}
        show="past"
      />

      <DutyPlannerFormModal
        isOpen={isFormOpen}
        onClose={() => {
          setIsFormOpen(false)
          setId(id + 1)
        }}
        id={null}
      />

      {permissions.addHoliday && (
        <ActionFab
          label="Adicionar feriado ou plantão"
          onClick={() => {
            setIsFormOpen(true)
          }}
        />
      )}
    </>
  )
}
